import React, { useState, useRef, useEffect } from "react";
import "./_index.scss";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import "./_datePicker.scss";

const CostumDatePicker = (props) => {
  const {
    label,
    name,
    className,
    classNameIcon,
    withIcon,
    leftIcon,
    rightIcon,
    onClick,
    rangeDays,
    selectedDay,
    setSelectedDay,
    selectedDayRange,
    setSelectedDayRange,
    error,
    formik,
    placeholder,
    isDisabled,
    calendarPopperPosition,
    minDate,
    disableBeforeDate,
    minimumDateValue,
    ...rest
  } = props;

  // Create a ref for the date picker
  const datePickerRef = useRef(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [minimumDate, setMinimumDate] = useState(null);

  const calculateMinimumDate = () => {
    if (!disableBeforeDate || !minimumDateValue) {
      return minDate || null;
    }

    const dateObj = typeof minimumDateValue === 'string' 
      ? new Date(minimumDateValue) 
      : minimumDateValue;
    
    const localDate = new Date(dateObj);
    
    localDate.setDate(localDate.getDate() + 1);
    
    return {
      year: localDate.getFullYear(),
      month: localDate.getMonth() + 1, 
      day: localDate.getDate()
    };
  };

  useEffect(() => {
    const calculatedMinDate = calculateMinimumDate();
    setMinimumDate(calculatedMinDate);
    
    if (calculatedMinDate) {
      setCurrentMonth({
        year: calculatedMinDate.year,
        month: calculatedMinDate.month
      });
    } else {
      const now = new Date();
      setCurrentMonth({
        year: now.getFullYear(),
        month: now.getMonth() + 1
      });
    }
  }, [disableBeforeDate, minimumDateValue, minDate]);

  const handleCalendarOpen = () => {
    if (minimumDate && datePickerRef.current) {
      if (datePickerRef.current.setCalendarMonthYear) {
        datePickerRef.current.setCalendarMonthYear({
          year: minimumDate.year,
          month: minimumDate.month
        });
      }
    }
  };

  const convertISOToDateObject = (isoDate) => {
    if (!isoDate) return null;
    const date = new Date(isoDate);
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  };

  const field = formik?.getFieldProps(name);

  return (
    <>
      {!withIcon && (
        <div className={`form-control ${className}`}>
          {label && <label htmlFor={name}>{label}</label>}
          <div
            className={`${isDisabled
                ? "disabled-input costum-date-picker "
                : "costum-date-picker"
              } `}
          >
            <DatePicker
              ref={datePickerRef}
              value={field?.value ? (typeof field.value === 'string' ? convertISOToDateObject(field.value) : field.value) : null}
              onChange={(value) => {
                formik.setFieldValue(name, value);
              }}
              inputPlaceholder={placeholder}
              colorPrimary="#0fbcf9"
              colorPrimaryLight="rgba(75, 207, 250, 0.4)"
              shouldHighlightWeekends
              calendarPopperPosition={calendarPopperPosition}
              width="100%"
              minimumDate={minimumDate}
              defaultMonth={currentMonth || undefined}
              calendarClassName="custom-calendar"
              onCalendarOpen={handleCalendarOpen}
            />
            {error && (
              <p className="error">
                <ReportProblemIcon /> {error}
              </p>
            )}
          </div>
        </div>
      )}

      {withIcon && (
        <div className={` ${className}`}>
          {label && <label htmlFor={name}>{label}</label>}
          <div>
            <div className="field-global-wrapper">
              <div className="field-intern-wrapper">
                {leftIcon && typeof leftIcon === "string" ? (
                  <img src={leftIcon} alt={leftIcon} />
                ) : (
                  leftIcon
                )}
                <DatePicker
                  ref={datePickerRef}
                  value={field?.value}
                  onChange={(value) => {
                    formik?.setFieldValue(name, value);
                  }}
                  inputPlaceholder={placeholder}
                  colorPrimary="#0fbcf9"
                  colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                  shouldHighlightWeekends
                  calendarPopperPosition={calendarPopperPosition}
                  minimumDate={minimumDate}
                  defaultMonth={currentMonth || undefined}
                  onCalendarOpen={handleCalendarOpen}
                />
              </div>
              {rightIcon && typeof rightIcon === "string" ? (
                <img src={rightIcon} alt={rightIcon} onClick={onClick} />
              ) : (
                rightIcon
              )}
            </div>
            {error && (
              <p className="error">
                <ReportProblemIcon /> {error}
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CostumDatePicker;
